import { useContext, useState } from 'react';
import {
  Modal,
  ModalBody,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
} from 'reactstrap';
import {
  FaRegFaceLaugh,
  FaRegFaceMeh,
  FaRegFaceFrownOpen,
} from 'react-icons/fa6';
import { Language } from '../../App';

const FeedbackModal = ({ isOpen, toggle, onSubmit,loader }) => {
  const languageContext = useContext(Language);
  const { lang } = languageContext || { lang: {} };
  const [experience, setExperience] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = () => {
    onSubmit?.({ experience, description });
    setExperience('');
    setDescription('');
  };

  return (
    <Modal isOpen={isOpen} backdrop="static" toggle={toggle} centered>
      <ModalBody className="p-4">
        <h5 className="fw-semibold mb-2">{lang?.send_us_your_feedback}</h5>
        <p className="text-muted mb-4">
         {lang?.suggestion_or_bug}
        </p>

        <FormGroup>
          <Label for="experience">{lang?.how_was_your_experience}</Label>
          <div className="d-flex gap-4 mb-3" style={{ color: '#d9d9d9' }}>
            <FaRegFaceFrownOpen
              className={`feedback-icon ${experience === 'bad' ? 'active' : ''}`}
              title={lang?.bad}
              size={24}
              onClick={() => setExperience('bad')}
            />
             <FaRegFaceLaugh
              className={`feedback-icon ${experience === 'good' ? 'active' : ''}`}
              title={lang?.good}
              size={24}
              onClick={() => setExperience('good')}
            />
            <FaRegFaceMeh
              className={`feedback-icon ${experience === 'average' ? 'active' : ''}`}
              title={lang?.average}
              size={24}
              onClick={() => setExperience('average')}
            />
           
          </div>
        </FormGroup>

        <FormGroup>
          <Label for="description">{lang?.describe_your_experience}</Label>
          <Input
          style={{borderRadius:"16px"}}
            type="textarea"
            id="description"
            placeholder={lang?.write_here}
            rows="5"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormGroup>
        <Button style={{borderRadius:"16px",color:"white",backgroundColor:"#031316"}}  block className="mt-2 p-3" onClick={handleSubmit}>
         {loader?<Spinner size="sm"/>: lang?.send_feedback}
        </Button>
        <Button style={{color:"#031316",backgroundColor:"white",
          border:" 0px",
          fontSize: "17px",
          marginBottom: "-12px"
        }}  block className="btn mt-2 p-3" onClick={()=> {toggle(); setExperience(''); setDescription('');}}>
          {lang?.cancel}
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default FeedbackModal;
